/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useRef, useState,useEffect,useCallback,useContext } from 'react'
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid, EditModal, CancelModal, CartModal, ConfirmModal, QRCodeModal,UpliftActionModal,NGODatePicker} from '../../../common';
import {capitalizeFirstLetter,formatDateByTimezone,getCultureFromLs,getTimeZoneAbbreviation,storageUtil,calculateTextWidth,getEndDateMaxLimit} from '../../../utils/commonFunctions';
import {customSelSearch,UPLIFT_MAX_LIMIT } from "../../../utils/configs";
import {
    InstanceStates,SectorRenderer
  } from "../../sales/inner-components/renderers";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import cartIcon from "../../../assets/icons/carts.svg";
import confirmIcon from "../../../assets/icons/confirm.svg";
import cancelIcon from "../../../assets/icons/cancel.svg";
import Select from 'react-select';
import qrcodeIcon from "../../../assets/qrCode.svg";
import viewIcon from "../../../assets/view.svg";
import moment from 'moment-timezone'
import { IoFlask } from "react-icons/io5";
import { FaPersonCircleCheck } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { FaPersonChalkboard } from "react-icons/fa6";
import { IoBarcodeOutline } from "react-icons/io5";
import { RiQrScan2Line } from "react-icons/ri";
import LoadingGIF from '../../../assets/loadingIn.gif';
import usePermissions from '../../../utils/userPermissions';
import CustomSelect from '../../../common/CustomSelect';
import downloadMasterIcon from '../../../assets/icons/download-master.svg';
import {ThemeContext} from '../../../contexts/themeContext';
import closeIcon from "../../../images/icons/Icon2.png"
const DOWNLOAD_STATUS_CHECK_INTERVAL = 6000; // 6 seconds
  const message = "No Data";
  const searchKey = '';

export const Uplifts = (props) => {
  const {viewOnly,groupDetails}=props;
  let updatedEditFields=[];
  const { t ,ready} = useTranslation();
  const {themedColor} = useContext(ThemeContext);

  const [state, setState] = useState({searchResponse:[],sectorSelect:[],minDate:null,maxDate:null,flightDate:viewOnly?new Date(formatDateByTimezone( props.groupDetails?.startTime)):formatDateByTimezone(storageUtil.get('dateUplift','session'))?new Date(formatDateByTimezone(storageUtil.get('dateUplift','session'))):new Date(),isReloadTableData:false});
  const [ modalTitle, setModalTitle ] = useState('');
  const { hasPermission: createUplifts } = usePermissions('create', 'orn:Store:ManageUplift');
  const { hasPermission: editUplifts } = usePermissions('edit', 'orn:Store:ManageUplift');
  const { hasPermission: viewUplifts } = usePermissions('viewDetails', 'orn:Store:ManageUplift');
  const { hasPermission: downloadUplift } = usePermissions('download', 'orn:Store:ManageUplift');
  const { hasPermission: approveUplift } = usePermissions('approve', 'orn:Store:ManageUplift');
  const { hasPermission: approveUpliftConfirmation } = usePermissions('approve', 'orn:Store:ConfirmUplift');
  const { hasPermission: printUplifts } = usePermissions('print', 'orn:Store:ManageUplift');
  const { hasPermission: deleteUplifts } = usePermissions('delete', 'orn:Store:ManageUplift');

  const tableRef = useRef();
const pageRef = useRef(new Set());
  const dataChange=useRef(false);
  const navigate = useNavigate();
  const [perPageLimit, setPerPageLimit] = useState(UPLIFT_MAX_LIMIT);
  // eslint-disable-next-line no-unused-vars
  const [itemTypeList, setItemTypeList] = useState([]);
  const [itemType, setItemType] = useState('');
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [modalCustomButtons,setModalCustomButtons]=useState([]);
  const [cateringGroupWidth, setCateringGroupWidth] = useState('17rem');
   const [EditFieldsCess, setEditFieldsCess] = useState([]);
  const [showUpliftSector, setShowUpliftSector] = useState({sector:false,updateSector:false});
  const [createUpliftDate, setCreateUpliftDate] = useState(moment().format());
  const [promptError, setPromptError] = useState([]);
  const [pendingCount,setPendingCount]= useState({total:0,pending:0});
  const [optionsWarehouse, setOptionsWarehouse] = useState([{key: 0, label: 'Select Warehouse', label2: 'Select Warehouse',value: ''}]);
  const [optionsLocations,setOptionsLocations]=useState([{key: 0, label: 'Select Location', value: ''}]);
  const [optionsSector, setOptionsSector] = useState([{key: 0, label: 'Select Sector', value: ''}]);
  const [optionsSectorFilter,setOptionsSectorFilter]=useState([]);
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'});
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoadingCateringGroups, setIsLoadingCateringGroups] = useState(false);
  const [isLoadingCateringGroupsSelect, setIsLoadingCateringGroupsSelect] = useState(false);
  const [showDownload, setShowDownload] = useState(false)
  const [reportDownloadErr, setReportDownloadErr] = useState(null)
  const [buttonStatus,setButtonStatus]=useState(false);
  const [reportFilter, setReportFilter] = useState({
    startDate:new Date(),
    endDate:new Date(),
    reportType:"",
    storeId:"",
    date: new Date(),
    cateringGroup: null,
    warehouseId: "",
    store: null,
  })
  const [cateringGroupOptions, setCateringGroupOptions] = useState([]);
  const [upliftVarianceWarehouses, setUpliftVarianceWarehouses] = useState([]);

  useEffect(() => {
    getSectors();
    return ()=>{
      if (viewOnly){
      storageUtil.clear('dateUplift','session');
      }
    }
  }, [])

  useEffect(() => {
  if (reportFilter.reportType === 'upliftVarianceReport') {
    const today = new Date();
    onDateChangeRep({ target: { name: 'date', value: today } });
  }
}, [reportFilter.reportType]);


  let yesterday =null;
  let tomorrow = null;

useEffect(() => {
  if (props && groupDetails && optionsSectorFilter.length > 0 && !dataChange.current) {
    const { sectors, startTime, warehouse } = props.groupDetails || {};
    const formattedDate = formatDateByTimezone(startTime);
    const date = formattedDate ? new Date(formattedDate) : new Date();
     yesterday = new Date(date);
     tomorrow = new Date(date);
     yesterday.setDate(date.getDate() - 1);
     tomorrow.setDate(date.getDate() + 1);

    setState((prevState) => {
      const newState = {
        ...prevState,
        warehouseSel: warehouse?.warehouseId,
        minDate:yesterday,
        maxDate:tomorrow,
        flightDate: !dataChange.current ? date : prevState.flightDate, 
      };
      if (Array.isArray(sectors)) {
        if (sectors.length === 1 && optionsSectorFilter.length === 1) {
          newState.sectorSelect = optionsSectorFilter;
        } else if (sectors.length > 1 && optionsSectorFilter.length > 1) {
          newState.sectorSelect = [optionsSectorFilter[0]];
        }

        newState.isReloadTableData=!prevState.isReloadTableData
      }

      return newState;
    });

    dataChange.current = true;
  }
}, [props, optionsSectorFilter]);

  async function getSectors(){
    try {
      const resp = await APIEndpoint.get('stores');
      if(resp.success){
        const setorList = resp.result.map(data=>{
          const sector = {
            key:data.id,
            label:`${data.flightNumber}-${data.origin}-${data.destination}`,
            value:data.id
          }
          return sector
        })
        if(setorList.length > 0 && !viewOnly){
          setOptionsSectorFilter([...setorList])
        }else{
          const upliftOptions= setorList.filter(option => 
          groupDetails.sectors?.some(sector => sector.key === option.label));
           setOptionsSectorFilter([...upliftOptions]);
            dataChange.current=false;
        }

      }
    } catch (error) {
    
    }
  }
  useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'35vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]); 

  useEffect(() => {
    fetchTimezone()
  }, [])

  async function fetchTimezone(){
    try {
      const res = await APIEndpoint.get("customer/app/config")
      if(res.success){
        const {name} = res.result.timezone
        setState(prev=>({...prev,timezone:name}))
      }
    } catch (error) {
      console.log(error)
    }
  }
  const SectorsCellRenderer = (data) => {
const {value,headerName}=data;

    if( value && Array.isArray(value) && value.length){
    return (
      <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',overflow:'auto',maxWidth:'225px'}}>
        <div className={`sector-container ${headerName} justifyContentFlexStart alignItemsCenter`} style={{maxWidth:'200px',flexWrap:'wrap',gap:5}}>{value.map((key, index) => (
          <span key={index} title={key} className={!index?"sector-label-minGrid margSecotInit":"sector-label-minGrid"}>{key}</span>
        ))}</div>
           {viewUplifts && !viewOnly ? <button className="sector-button margLeft6"  style={{position:'absolute',right:0}} onClick={(e) => setSector({sectors:value}, 'sector')}>...</button> : null}
      </div>
      </>

    );
    }else if(value && Array.isArray(value)&&!value.length){
      return (
        <div className={`sector-container ${headerName}`}>
          None
        </div>)
    }
    else if(value && !Array.isArray(value)){
      return (
        <><div className='flexRow justifyContentSpaceBetween'  style={{width:'100%',maxWidth:'225px',overflow:'auto'}}>
        <div className={`sector-container ${headerName} justifyContentFlexStart alignItemsCenter`} style={{marginRight:'1.5rem',maxWidth:headerName!=='Sectors'?'80px':'auto'}}>
          <span className="uplift-user" style={{width:'200px'}}>{value?.employeeName??""}{value?.employeeCode && value?.employeeCode!==value?.employeeName ?` (${value?.employeeCode})`:null}</span>
        </div>
      </div>
      </>
        )
    }else{
     return (<div className={`sector-container ${headerName}`}>

        </div>)
    }


  };

  const updteStatusRender = (ltst) => {


    if( ltst && !Array.isArray(ltst)){
    return (
      <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'225px',overflow:'auto'}}>
        <div className='sector-container margRight justifyContentFlexStart alignItemsCenter'>
          <span  className="sector-label">Last update: {ltst.label} @ {moment(ltst.timestamp).tz(moment.tz.guess()).format("DD-MM-YYYY hh:mm A")}</span> +1 More
      </div>
      </div>
      </>

    );
    }else{
     return (<div className='sector-container'>

        </div>)
    }


  };


  const onColumnResizedHandler=(e)=>{

    if (e && e.column?.getColId() === 'sectors' && e.column?.getColDef().headerName==="Sectors") {
      const newWidth = e?.column.actualWidth;
      const sectorCells = document.querySelectorAll('.sector-container-main');
      sectorCells.forEach(cell => {
        cell.style.maxWidth = `${newWidth}px`;
      });
    }
    if (e && e.column?.getColId() === 'upliftedBy' && e.column?.getColDef().headerName==="Uplifted By") {
      const newWidth = e?.column.actualWidth;
      const sectorCells = document.querySelectorAll('.sector-container.Uplifted By');
      sectorCells.forEach(cell => {
        cell.style.maxWidth = `${newWidth}px`;
      });
    }
    if (e && e.column?.getColId() === 'confirmedBy' && e.column?.getColDef().headerName==="Confirmed By") {
      const newWidth = e?.column.actualWidth;

      const sectorCells = document.querySelectorAll('.sector-container.Confirmed By');
      sectorCells.forEach(cell => {
        cell.style.maxWidth = `${newWidth}px`;
      });
    }
  }


  const Columns = [
    { field: 'storeName', headerName: 'Sector',resizable:true,flex:1, minWidth: 165, width:170,maxWidth:250,pinned: 'left', cellRendererSelector: (params) => {
      return {
        component: SectorRenderer,
      };
    }},
    {
      field: 'targetDate', headerName: 'Flight Date', minWidth: 100,flex:1,
      valueGetter: (params) => {
        return params?.data ? moment.parseZone(formatDateByTimezone(params?.data?.targetDate)).format("DD-MM-YYYY"):null
      }
    },
    { field: 'location', headerName: 'Location',resizable:true, minWidth: 110,flex:1, },
    {
      field: 'warehouse', headerName: 'Warehouse', minWidth: 150,flex:1,
      resizable: true,
      valueGetter: (params) => {
    const c = params.data?.warehouse?.warehouseName;
    if (!c) return null;

    const parts = c.trim().split(' ');
    if (parts.length > 0) {
      const lastWord = parts[parts.length - 1].toLowerCase();
      return lastWord.includes('warehouse')
        ? parts.slice(0, -1).join(' ')
        : c;
    }
    return c;
  }
    },
    {
      field: 'upliftedBy', headerName: 'Created By',flex:1, minWidth: 130,width:165,
      resizable: true,cellRendererFramework: (params) => (
        <SectorsCellRenderer
          {...params}
          headerName={params.colDef.headerName}
        />
      ),

    },
    {
      field: 'dateCreated', headerName: 'Created At', minWidth: 150,maxWidth:200,flex:1,
      valueGetter: (params) => {
        return params?.data?.dateCreated ? moment(params.data?.dateCreated).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):null
      }
    },
    { field: 'status', headerName: 'Status', flex:1,minWidth: 100,cellRendererSelector: (params) => {
            return {
              component: InstanceStates,
            };
          }},
    {
      field: 'confirmedBy', headerName: 'Confirmed By', minWidth: 155,flex:1,width:150,maxWidth:350,
      resizable: true,cellRendererFramework: (params) => (
        <SectorsCellRenderer
          {...params}
          headerName={params.colDef.headerName}
        />
      ),

    },
    {
      field: 'confirmedAt', headerName: 'Confirmed At',flex:1, minWidth: 150,width:155,
      valueGetter: (params) => {
        return params?.data?.confirmedAt ? moment.tz(params?.data?.confirmedAt,state.timezone).format('DD-MM-YYYY hh:mm A'):null
      }
    },
    {
      field: 'items', minWidth: 115,flex:1,
      headerName: 'Summary',
      valueGetter: (params) => {
        return params?.data ? `${params.data?.items.length || 0} items`:null
      }
    },
    { field: 'sectors', headerName: 'Sectors',flex:1,width:275, minWidth: 270,cellRendererFramework: (params) => (
      <SectorsCellRenderer
        {...params}
        headerName={params.colDef.headerName}
      />
    ),},
   {
    headerName:'Actions',
    width: !viewOnly ? 190 : 90,
    maxWidth: !viewOnly ? 210 : 100,
    resizable: !viewOnly,
    cellRenderer: ActionComponent,
    pinned: 'right',
    headerClass: !viewOnly ? 'actions-header' : undefined,
  },
  ];

  function getUpliftRunningIcons(dta,cState) {
    switch (cState) {
      case "upliftCreated":
        return (<>
          <span
            title="Request Review"
            onClick={() => onAction(dta, 'reviewRequested')}
          >
            <FaPersonCircleCheck size={20} className="scanqr-uplift" />
          </span>
        </>
        );
        case 'reviewRequestedFromCateringManager':
        return (
            approveUplift && (
              <span
                title="Review Uplift"
                onClick={() => onAction(dta, 'requestCateringReview')}
              >
                <GrUserManager size={20} className="scanqr-uplift" />
              </span>
            )
              );

        case 'awaitingItemScanAndLoad':
        return (
          <>
        <span
            title="Scan Items"
            onClick={() => onAction(dta, 'ScanInventory')}
          >
            <IoBarcodeOutline size={20} className="scanqr-uplift" />
          </span>
          <span
            title="Request Confirmation"
            onClick={() => onAction(dta, 'awaitingItemScanAndLoad')}
          >
            <FaPersonChalkboard size={20} className="scanqr-uplift" />
          </span>

          </>
        );
        case 'awaitingItemProcessingAndLoading':
          return (
            <>
          <span
            title="Scan Items"
            onClick={() => onAction(dta, 'ScanInventory')}
          >
            <IoBarcodeOutline size={20} className="scanqr-uplift" />
          </span>
     {approveUpliftConfirmation? <img className="edit mx-2" alt='items' title="Confirm" src={confirmIcon} onClick={(e) => onAction(dta,'ConfirmItem')}/>:null}
            </>
          );

      default:
        return null;
    }
  }

  function ActionComponent(props) {
  
    if(!props.data) return null;
    if (viewOnly && viewUplifts) {
    return (
      <div className="pointer flexRow">
        <img
          className="edit mx-2"
          alt="items"
          title="View Items"
          src={viewIcon}
          onClick={() => onAction(props.data, 'ViewItem')}
        />
      </div>
    );
  }

    if(props.data?.status === 'created' && viewUplifts){
      const {currentState} = props.data.workflow || { currentState: null };
      return (
       <div className="pointer flexRow">
        {editUplifts && (
          <>
            <img
              className="edit mx-2"
              alt="items"
              title="View Items"
              src={viewIcon}
              onClick={() => onAction(props.data, 'EditItem')}
            />
            {getUpliftRunningIcons(props.data, currentState)}
          </>
        )}
        {deleteUplifts && (
          <img
            className="edit mx-2"
            alt="items"
            title="Cancel"
            src={cancelIcon}
            onClick={() => onAction(props.data, 'CancelItem')}
          />
        )}
      </div>);
    }else if(props.data?.status === 'confirmed' && viewUplifts){
      return (
       <div className="pointer flexRow">
  <img
    className="edit mx-2"
    alt="items"
    title="Items"
    src={viewIcon}
    onClick={() => onAction(props.data, 'ViewItem')}
  />
  <img
    className="edit mx-2"
    alt="items"
    title="Carts"
    src={cartIcon}
    onClick={() => onAction(props.data, 'CartItem')}
  />
  
  {printUplifts && (
    <img
      className="edit mx-2"
      alt="items"
      title="QR Code"
      src={qrcodeIcon}
      onClick={() => onAction(props.data, 'QRCode')}
    />
  )}

  {deleteUplifts && (
    <img
      className="edit mx-2"
      alt="items"
      title="Cancel"
      src={cancelIcon}
      onClick={() => onAction(props.data, 'CancelItem')}
    />
  )}
</div>

      );
    }else if(props.data?.status === 'completed'&& viewUplifts){
      return (
        <div className="pointer flexRow" >
          <span title={"Scan"} onClick={()=>onAction(props.data, 'ScanInventory')}><RiQrScan2Line size={20} className="scanqr-uplift" /></span>
          <img className="edit mx-2" title="Items" alt='items' src={viewIcon} onClick={(e) => onAction(props.data, 'ViewItem')}/>
          <img className="edit mx-2" title="Carts" alt='items' src={cartIcon} onClick={(e) => onAction(props.data, 'CartItem')}/>
         {printUplifts ?<img className="edit mx-2" title="QR Code" alt='items' src={qrcodeIcon} onClick={(e) => onAction(props.data, 'QRCode')}/>:null}
        </div>
      );
    }else {
      return (
        <div className="pointer flexRow" >
          <img className="edit mx-2" alt='items' title="Items" src={viewIcon} onClick={(e) => onAction(props.data, 'ViewItem')}/>
          <img className="edit mx-2" alt='items' title="Carts" src={cartIcon} onClick={(e) => onAction(props.data, 'CartItem')}/>
        </div>
      );
    }

  }

  function StatusRenderer(params, updatedStatus = null) {
    const getStatusLabel = (status) => {
      switch (status) {
        case 'completed':
          return 'Processed';
        case 'created':
          return 'Pending';
        default:
          return capitalizeFirstLetter(status);
      }
    };
    if (!updatedStatus) {
      return <span>{getStatusLabel(params?.data?.status)}</span>;
    }else{
      const { data } = params || {};
      const { latestUpdateDescriptor, nextUpdateDescriptor } = data || {};
      if(!latestUpdateDescriptor || !Object.keys( latestUpdateDescriptor).length)return <></>;
      const sectorUpdates = [{
      latestUpdate: { ...latestUpdateDescriptor },
      nxtUpdate: { ...nextUpdateDescriptor }
      }];
    return (
   <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'275px'}}>
       <span>{params?.data?.latestUpdateDescriptor?updteStatusRender(params?.data?.latestUpdateDescriptor,params.data.nextUpdateDescriptor):""}</span>
      <button className="sector-button" onClick={(e) => setSector({sectors:sectorUpdates}, 'updtSector')}>...</button>
    </div>
    </>)
    }

  }


  function onDateChange(e){
        const parsedDate = new Date(formatDateByTimezone(e.target.value));
        storageUtil.set('dateUplift', isNaN(parsedDate.getTime()) ? null: parsedDate, 'session');
    setState( (_prev) => {
        return { ..._prev,flightDate:e.target.value,isReloadTableData:!state.isReloadTableData}
      });
      pageRef.current = new Set();
      setPendingCount({ total: 0, pending: 0 });
  }

  function onChangeLocation(selectedVal){
    const val = selectedVal?.value;
    setState((_)=>({..._,locationSelect:val,isReloadTableData:!state.isReloadTableData}))
  }

  function onChangeSectors(e){
      setState((_)=>({..._,sectorSelect:[e],isReloadTableData:!state.isReloadTableData}));
      pageRef.current = new Set();
      setPendingCount({ total: 0, pending: 0 });
  }

  function onWarehouseChange(selectedVal){
    if(!viewOnly){
      const val = selectedVal?.value;
      setState((_)=>({..._,warehouseSel:val,isReloadTableData:!state.isReloadTableData}))
    }else{
      return;
    }
  }

  const setSector = (data,type) => {
    setState( (_prev) => {
      return { ..._prev, selected: {...data ,action: type}}
    });
    type!=='updtSector'? setShowUpliftSector((_)=>({..._,sector:true})):setShowUpliftSector((_)=>({..._,updateSector:true}))
  };

  const EditFormFields = [
    {label: 'Csv', attribute: 'items', type: 'csv', disabled: false, options: [], value: [] },
  ];

  const AddFormFields = [
    {label: 'Warehouse', attribute: 'warehouse', type: 'selectSearch2', disabled: false, options: optionsWarehouse, required: true },
    {label: 'Sector', attribute: 'sector', type: 'selectSearch2', disabled: false, options: optionsSector, required: true },
    {label:  `Flight Date *(in ${getTimeZoneAbbreviation(getCultureFromLs()?.timezone)})`, attribute: 'flightDate', type: 'date', disabled: false, required: true},
  ];


  React.useEffect(() => {
    fetchWarehouses();
    fetchAirports();
    setItemTypeList([{key: 0, label: "Confirmed", value: 'confirmed'},{key: 1, label: "Pending", value: 'created'},{key: 2, label: "Processed", value: 'completed'},{key: 3, label: "Cancelled", value: 'cancelled'}]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect( () => {
    refreshTable();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemType, tableRef]);

  const refreshTable = () => {
    tableRef.current?.refreshTableHandler(itemType);
      pageRef.current = new Set();
      setPendingCount({ total: 0, pending: 0 });
  };

  const fetchWarehouses = async () => {
    try {
       const resp = await APIEndpoint.get('warehouses');
    if (resp.result.length > 0) {
      const options = [{key: 0, label: 'Select Warehouse', label2:'Select Warehouse',value: ''}];
      resp.result.filter( (fieldValue, index) => {
        options.push({key: fieldValue.id, label: fieldValue.value,value: fieldValue.id});
        return fieldValue;
      });
      setOptionsWarehouse(options)
    } else {
      console.log('Log: Error while fetching warehouses');
    }
    } catch (error) {

    }

  };

  const fetchAirports = async () => {
    try {
       const resp = await APIEndpoint.get('airports');
    if (resp.items.length > 0) {
      const options = [{key: 0, label: 'Select Location', value: ''}];
      resp.items.filter( (fieldValue, index) => {
        options.push({key: fieldValue.id, label: fieldValue.locationCode, value: fieldValue.locationCode});
        return fieldValue;
      });
      setOptionsLocations(options)
    } else {
      console.log('Log: Error while fetching warehouses');
    }
    } catch (error) {

    }

  };

  const fetchSectors = async (id) => {
    if(optionsSector && optionsSector.length>1)return;
    try {
      const resp = await APIEndpoint.get('warehouses/sectors/'+id);
    if (resp.result.length > 0) {
      const options = [{key: 0, label: 'Select Sector', value: ''}];
      resp.result.filter( (fieldValue, index) => {
        options.push({key: fieldValue.storeId, label: fieldValue.flightNumber+ " ("+ fieldValue.originName+" - "+fieldValue.destinationName+") ", value: fieldValue.storeId});
        return fieldValue;
      });
      setOptionsSector(options)
    } else {
      const options = [{key: 0, label: 'Select Sector', value: ''}];
      setOptionsSector(options)
      console.log('Log: Error while fetching sectors');
    }
    } catch (error) {

    }

  };
  const handleReset = () => {
    let timer = setTimeout(() => {
      clearTimeout(timer);
      setModalFormStatusObj({text:""});
      setEditFieldsCess([]);
      setModalCustomButtons([]);
      setState((_) => {
        return { ..._, selected: null,isReloadTableData: !_.isReloadTableData };
      })
      pageRef.current = new Set();
      setPendingCount({ total: 0, pending: 0 });
    }, 1800)
  }
const enableButtons = (submitBtnObj, cancelButtonObj) => {
  submitBtnObj?.removeAttribute('disabled');
  if(cancelButtonObj){
  cancelButtonObj?.removeAttribute('disabled');
  }
};


  const onEnableDisableAction = async (dec=null,data) => {
    if(!data){
      return;
    }
    const payload = {
      "event": dec,
      // "storeId": data?.storeId,
    };
        const submitBtnObj = document.getElementsByClassName('done-button')[0];
        const cancelButtonObj = document.getElementsByClassName('cancel-button')[0];

        submitBtnObj?.setAttribute('disabled', 'true');
        cancelButtonObj?.setAttribute('disabled', 'true');

       try {
      const res = await APIEndpoint.post(`uplifts/${data.id}/update-workflow`, payload);
      if(res && res.success){
        setModalFormStatusObj({text:res.msg||'Review requested'});
      setTimeout(() => {
        enableButtons(submitBtnObj,cancelButtonObj)
    }, 1800);
        handleReset();
      }

    } catch (error) {
      let {data}=JSON.parse(error.message);
      setModalFormStatusObj({error:data?.msg || 'Failed to send review request'})
      setTimeout(() => {
        enableButtons(submitBtnObj, cancelButtonObj)
    }, 1800);

    }

      }


  const onAction = (selectedRowData,action) => {
    setModalFormStatusObj({text:""});
    if(action==='reviewRequested'){
      setModalTitle(t('pages.inventoryContent.uplifts.requestReview'));
      updatedEditFields = [
        {
            label: 'Request review of uplift plan from catering manager.',
            attribute: 'alertMessage', type: 'alertMessage'
        }
    ];
    setModalCustomButtons([
                         {label:'Request Review',attribute:'button',type:"button",disabled:false,className:'submit-button',action:()=>onEnableDisableAction('reviewRequested',selectedRowData)}])
                         setState( (_prev) => {
                          return { ..._prev, selected: {...selectedRowData,  action: action }}
                        });
    setEditFieldsCess(updatedEditFields);
    setState( (_prev) => {
      return { ..._prev, selected: {...selectedRowData,...updatedEditFields[0],  action: action }}
    });
    }
    else if(action==='requestCateringReview'){
      setModalTitle(t('pages.inventoryContent.uplifts.reviewUplift'));
      updatedEditFields = [
        {
            label: 'Approve or reject uplift plan.',
            attribute: 'alertMessage', type: 'alertMessage'
        }
    ];
    setModalCustomButtons([
                         {label:'Approve',attribute:'button',type:"button",disabled:false,className:'submit-button',action:()=>onEnableDisableAction('approved',selectedRowData)},
                         {label:'Reject',attribute:'button',type:"button",disabled:false,className:'cancel-button',action:()=>onEnableDisableAction('rejected',selectedRowData)}

                        ])
                         setState( (_prev) => {
                          return { ..._prev, selected: {...selectedRowData,  action: action }}
                        });
    setEditFieldsCess(updatedEditFields);
    setState( (_prev) => {
      return { ..._prev, selected: {...selectedRowData,...updatedEditFields[0],  action: action }}
    });
    }
    else if(action==='awaitingItemScanAndLoad'){
      setModalTitle(t('pages.inventoryContent.uplifts.requestConfirmation'));
      updatedEditFields = [
        {
            label: 'Request confirmation of uplift plan from warehouse officer.',
            attribute: 'alertMessage', type: 'alertMessage'
        }
    ];
    setModalCustomButtons([
      {label:'Request Confirmation',attribute:'button',type:"button",disabled:false,className:'submit-button',action:()=>onEnableDisableAction('approved',selectedRowData)}])
                         setState( (_prev) => {
                          return { ..._prev, selected: {...selectedRowData,  action: action }}
                        });
    setEditFieldsCess(updatedEditFields);
    setState( (_prev) => {
      return { ..._prev, selected: {...selectedRowData,...updatedEditFields[0],  action: action }}
    });
    }
    else{
          setState( (_prev) => {
      return { ..._prev, selected: {...selectedRowData,  action: action }}
    });
    }

    /**
     * Set to edit form
     */

    EditFormFields.map( editRow => {
      if (editRow.attribute === 'items' ) {
        editRow.value = selectedRowData;
      }
      return editRow;
    });
    if(action==='ScanInventory'){
    navigate('main/inventory/scan',{state:{scanId:selectedRowData.id,warehouseName:selectedRowData.warehouse?.warehouseName??null,currentState:selectedRowData?.workflow?.currentState}})
    }
  };

  const onClose = () => {
    setModalFormStatusObj({ text: '' });
    setShowUpliftSector({sector:false,updateSector:false})
    setState((_prev) => {
      return { ..._prev, selected: false }
    });
    setPromptError([]);
    setButtonStatus(false);
  }


function upliftSeachFilters(){
  let filters=[];
  let filterConditions = [
    { condition: "itemType", filter: {"status":itemType||null } },
    { condition: "location", filter: {"location":state.locationSelect||null } },
    { condition: "warehouseId", filter: { "warehouseId":state.warehouseSel||null } },
    { condition: "storeId", filter: { "storeId":state.sectorSelect[0]?.value||null} },
    { condition: "flightDate", filter: {"flightDate":state.flightDate?formatDateByTimezone(state?.flightDate):null } },

  ];

  filterConditions.forEach(({ condition, filter }) => {
    if (condition) {
      const existingFilterIndex = filters.findIndex(existingFilter => {
        return Object.keys(existingFilter).every(key => filter.hasOwnProperty(key));
      });

      if (existingFilterIndex !== -1) {
        const existingFilter = filters[existingFilterIndex];
        filters[existingFilterIndex] = { ...existingFilter, ...filter };
      } else {
        filters.push(filter);
      }
    }
  });
  return filters;
}


  async function getPendingStatusCount(dataPromise) {
    const selDate = formatDateByTimezone(state?.flightDate, true)?.split("T")[0];  
    const countArr = await dataPromise;
    let count = 0;
    if (!(pageRef.current instanceof Set)) {
    pageRef.current = new Set();
    }
    if (pageRef.current.has(countArr.page)) {
    return;
    }

    pageRef.current.add(countArr.page);
    if (Array.isArray(countArr.res) && countArr.res.length>0) {
      countArr.res.forEach((item) => {
        const itemDate = item?.targetDate?.split("T")[0];
        if (itemDate === selDate && item.status === "created") {
          count++;
        }
      });
   setPendingCount((_) => ({..._, total: _.total + countArr.res.length, pending: _.pending + count}));
    }
  }

  const filterData = {
    action: 4,
    filters: [],
    limit: UPLIFT_MAX_LIMIT,
    page: 1,
  };

  const fetchUplifts = useCallback(async (page=1, perPage=50) => {
    if(viewOnly && !state.sectorSelect.length)return;
    filterData.page = page;
    filterData.limit = UPLIFT_MAX_LIMIT;
    filterData.sort=[
      {
          field: "targetDate",
          order: "desc"
      }
  ]
  const filtersArr=upliftSeachFilters().filter(item=>Object.values(item)[0]!==null);
  filterData.filters = filtersArr;
try {
  const res = await APIEndpoint.post('uplifts/process', JSON.stringify(filterData));
       getPendingStatusCount({res:res?.items,page:page }|| {});
      return res;

} catch (error) {

}

  }
   
    ,[upliftSeachFilters,dataChange.current,state])

  const onEditSubmit = async (e, updated) => {
    setModalFormStatusObj({ text: '' });
    if(state.selected.action === 'ViewItem'){
      onClose();
      return;
    }
    if(state.selected.action !== 'EditItem'){
      setModalFormStatusObj({ text: '' });
      if(updated) {
        // const body = { ...state.selected, ...updated };
        toUpliftAddNavigate(updated)
        // sType === 'dfp' ? await DFPAPIEndpoint.put('itemMaster', body) : await APIEndpoint.put('itemMaster', body);
        setModalFormStatusObj({ text: 'Saved successfully.' });
      }else{
        setModalFormStatusObj({ error: 'Please provide all the required fields' });
      }
    }
    // onClose();
  };

  const onPromptSubmit = async (e, updated,mode) => {
    if (updated) {
      const body = { storeId: updated.storeId};
       const submitBtnObj = document.getElementsByClassName('done-button')[0];    
        submitBtnObj?.setAttribute('disabled', 'true');
      try{
         
        let res;
        (mode === 'Cancel Uplift') ?
        res =  await APIEndpoint.post('uplifts/'+updated.id+'/cancel', body)
      :
      res = await APIEndpoint.post('uplifts/'+updated.id+'/confirm', body);

       if (res && res?.success) {
        const message = res?.msg || res?.message;
        setModalFormStatusObj({ text: message });
        const currentSelected = { ...updated };

        setTimeout(() => {
        enableButtons(submitBtnObj, null);
        const latestNavDetails = storageUtil.get('SALES_SYNC_NAV', 'session') || {};
        const stateSynced = latestNavDetails?.stateSynced;
        const upliftIdNav = latestNavDetails?.upliftId;
        const name = stateSynced?.name;
        const navId = stateSynced?.id;
        if(!stateSynced){
          storageUtil.clear('SALES_SYNC_NAV', 'session');
        }
        if (upliftIdNav && name) {
            const { id } = currentSelected; 

            if (String(upliftIdNav) === String(id)) {
                const encodedName = encodeURIComponent(name);
                storageUtil.clear('SALES_SYNC_NAV', 'session');
                navigate(`/sales/dynamic/sector/containerIsolate/${encodedName}/${navId}`);
                return;
            }
        }

        refreshTable();
        onClose();
        }, 1800);

      }
      setTimeout(() => {
      refreshTable()
      onClose();
      }, 2000);

      }catch(error){
        let {data}=JSON.parse(error.message)
        setModalFormStatusObj({error:data?.msg});
        setPromptError(data?.message || data?.msg);
         setTimeout(() => {
        enableButtons(submitBtnObj,null)
    }, 1800);
      }
    }
  };


  const onFieldChangeHandler = (e,updated) => {
    if(!updated?.warehouse || !updated?.sector || !updated.flightDate){
      setButtonStatus(true)
    }else if(updated?.warehouse && updated?.sector && updated?.flightDate){
      setButtonStatus(false)
    }
    setModalFormStatusObj({text:''})
    if(updated.flightDate){
      setCreateUpliftDate(moment(updated.flightDate).format())
    }
    if(updated.warehouse){
      fetchSectors(Number(updated.warehouse));
    }
  };

  const onAddItemHandler = () => {
    setState( (_prev) => {
      return { ..._prev, selected: { action: 'AddItem' } };
    });
  }

  // eslint-disable-next-line no-unused-vars
  const onPerLimitChange = (e) => {
    setPerPageLimit(Number(e.target.value));
  };

  const onItemTypeChange = (e) => {
      let status = e?.value || "";
      setItemType(status);
  }
  const toUpliftNavigate = (e) => {
    let id = state.selected.id
    navigate('main/inventory/editor/edituplift/'+id,{state:{upliftData:state.selected?.workflow?.currentState}})
  }

  const toUpliftAddNavigate = (updatedid) => {
    if(optionsSector.length>1){
      let dateid = formatDateByTimezone(createUpliftDate);
          const sectorData = optionsSector.find(data=>Number(data.value) === updatedid.sector);
      if(sectorData){
      navigate('main/inventory/editor/'+updatedid.warehouse+'/'+updatedid.sector+'/'+dateid,{state:{sectorName:sectorData.label??""}})
      }
    }
  }

  function clearErr(){
    setTimeout(() => {
        setReportDownloadErr(null)
    }, 3000);
  }

  function onUploadClose(){
    setShowDownload(false);
    setReportFilter({
    startDate:new Date(),
    endDate:new Date(),
    reportType:"",
    storeId:"",
    date: new Date(),
    cateringGroup: null,
    warehouseId: "",
    store: null,
  });
  setCateringGroupWidth('17rem');
  }

  function showDownloadHandler(){
    setShowDownload(true)
  }

  async function onDownloadReport(){

    if (reportFilter.reportType === 'upliftVarianceReport') {
      return await onDownloadUpliftVerifReport();
    }

    const body = {
    
      startDate:formatDateByTimezone(new Date(reportFilter.startDate),true),
      endDate: formatDateByTimezone(new Date(reportFilter.endDate),true),
      reportType: reportFilter.reportType,
      storeId:reportFilter.storeId
    };
    if(!body.reportType){
      setReportDownloadErr("Select report type!")
      clearErr()
      return;
    }
    let header = {
      Accept: "text/csv"
    };
    try {
      setIsDownloading(true)
      const res = await APIEndpoint.post(`sales/reports`, body, header);
      if(res.status === "scheduled"){
        setTimeout(async () => {
          try {
            const dowId = await APIEndpoint.get(`downloads/status/${res.id}`);
            const ItemMasterDwnld = await APIEndpoint.get(
              `downloads/analytics/${dowId.fileName}${dowId.fileExtension}`,
            );
            setIsDownloading(false)
            const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download",`${dowId.fileName}${dowId.fileExtension}`);
            document.body.appendChild(link);
            link.click();
          } catch (error) {
            setIsDownloading(false)
          }
        }, 5000);
      }
    } catch (error) {
      const err = JSON.parse(error.message);
      setReportDownloadErr(err.data?.message);
      setIsDownloading(false);
      clearErr();
    }
  }

  const dialogSelectStyles = {
    placeholder:(styles,state) => ({ ...styles, textAlign: "left",color:  state.isFocused ? '#6e7c84' : '#fff' }),
    indicatorSeparator: (provided) => ({ ...provided,display: 'none'}),
    singleValue: (styles) => ({ ...styles,textAlign:"left",color:"#fff" }),
    input: (styles) => ({ ...styles,textAlign:"left",color:"#fff" }),
        control: (provided, state) => ({
      ...provided,
      backgroundColor: '#1c2b40',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer', 
    }),
  };

  async function onDownloadUpliftVerifReport(){
    const body = {
      startDate: formatDateByTimezone(new Date(reportFilter.date),false),
      endDate: formatDateByTimezone(new Date(reportFilter.date),false),
      reportType: reportFilter.reportType,
      cateringGroup: reportFilter.cateringGroup,
      warehouseId: reportFilter.warehouseId ? Number(reportFilter.warehouseId) : null,
      store: reportFilter.store || null
    };
    if(!body.reportType){
      setReportDownloadErr("Select report type!");
      clearErr();
      return;
    }
    if (!body.startDate || !body.endDate) {
      setReportDownloadErr("Select the date!");
      clearErr();
      return;
    }
    if (!body.cateringGroup || !body.cateringGroup?.id) {
      setReportDownloadErr("Select the catering group!");
      clearErr();
      return;
    }
    if (!body.warehouseId) {
      setReportDownloadErr("Select the warehouse!");
      clearErr();
      return;
    }

    try {
      setIsDownloading(true);
      let header = {
        Accept: "text/csv"
      };
      
      const res = await APIEndpoint.post(`sales/reports`, body, header);
      if(res.status === "scheduled"){
        setTimeout(async () => {
          try {
            const dowId = await APIEndpoint.get(`downloads/status/${res.id}`);
            const ItemMasterDwnld = await APIEndpoint.get(
              `downloads/analytics/${dowId.fileName}${dowId.fileExtension}`,
            );
            setIsDownloading(false);
            const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download",`${dowId.fileName}${dowId.fileExtension}`);
            document.body.appendChild(link);
            link.click();
          } catch (error) {
            setIsDownloading(false);
            let errMsg = "An error occurred while downloading the report.";
            try {
              const err = JSON.parse(error.message);
              errMsg = err.data?.message || errMsg;
            } catch (e) {
              if (typeof error.message === "string") {
                errMsg = error.message;
              }
            }
            setReportDownloadErr(errMsg);
            clearErr();
          }
        }, DOWNLOAD_STATUS_CHECK_INTERVAL);
      }
      else {
        setIsDownloading(false);
        let errMsg = "An error occurred while downloading the report.";
        setReportDownloadErr(errMsg);
        clearErr();
      }
    } catch (error) {
      let errMsg = "An error occurred while downloading the report.";
      try {
        const err = JSON.parse(error.message);
        errMsg = err.data?.message || errMsg;
      } catch (e) {
        // If parsing fails, use the raw error message if available
        if (typeof error.message === "string") {
          errMsg = error.message;
        }
      }
      setReportDownloadErr(errMsg);
      setIsDownloading(false);
      clearErr();
    }
  }

   function onDateChangeRep(e){
    const {name,value} = e.target
    if(name === "startDate"){
      setReportFilter(prev=>({...prev,startDate:value,endDate:null}))
    }else if (name === "endDate"){
      setReportFilter(prev=>({...prev,endDate:value}))
    } else if (name === "date"){
      setReportFilter(prev=>({...prev,cateringGroup: null, warehouseId: "", store: null, date: value}));
      setCateringGroupOptions([]);
      setUpliftVarianceWarehouses([]);
      loadCateringGroupsByDate(value);
    }
  }

  async function loadCateringGroupsByDate(value) {
    setIsLoadingCateringGroupsSelect(true);
    setIsLoadingCateringGroups(true);
    try {
      const requestPayload = {
        date: formatDateByTimezone((new Date(value)??new Date()), false),
      };

      /** Get catering groups based on the selected date  */
      const response = await APIEndpoint.post(`operations/rotations/find`, requestPayload);

      let cateringGroupOptns = [];
      response.rotations.forEach(ele => {
        const dte =   moment(ele.legs[0]?.std).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A');

        const cateringGroupLegs = ele.legs.map(leg => ({ 
          key: leg.id,
          label: leg.origin,
          value: leg.origin,
          cateringGroup: { id: ele.id, name: ele.name },
          store: { flightNumber: leg.flightNumber, origin: leg.origin, destination: leg.destination }
        }));
        
        cateringGroupOptns.push({ key: ele.id, label:`${ele.tailNumber}/${ele.flightPath}/${dte}`, value: ele.id, legs: cateringGroupLegs });
      });

      setCateringGroupOptions(cateringGroupOptns);
    } catch (error) {
      console.error("Error loading catering groups:", error);
      let errMsg = 'Failed to load Catering Groups';
      try {
        const err = JSON.parse(error.message);
        errMsg = err.data?.message || errMsg;
      } catch (e) {
        errMsg = error.message || errMsg;
      }
      setReportDownloadErr(errMsg);
      clearErr();

    } finally {
      setIsLoadingCateringGroupsSelect(false);
       setIsLoadingCateringGroups(false);
    }
  }

  async function onCateringGroupChange(data) {
    const cateringGroup = data ? { id: data.value, name: data.label } : null;
    setReportFilter(prev => ({ 
      ...prev,
      cateringGroup,
      warehouseId: '',
      store: null
    }));

    const cateringGroupLegs = data?.legs || [];

    if (data?.label) {
      const newWidth = calculateTextWidth(data.label);
      setCateringGroupWidth(`${newWidth+100}px`);
    } else {
      setCateringGroupWidth('17rem'); 
    }



    if (cateringGroupLegs.length > 0) {
      // Make unique origins from catering group legs
      const uniqueCGroupOrigins = Array.from(
        new Map(cateringGroupLegs.map(item => [item.label, item])).values()
      );

      /** Get warehouses by calling /api/airports/:locationCode/warehouses API for each location value */
      let warehouseOptions = [];
      try {
        const warehousePromises = uniqueCGroupOrigins.map(async (whOptn) => {
          try {
            const response = await APIEndpoint.get(`airports/${whOptn.value}/warehouses`);
            return response.items.map(wh => {
              return ({ key: wh.warehouseId, label: `${wh.warehouseName} (${wh.warehouseCode})`, value: wh.warehouseId, store: whOptn.store});
            });
          } catch (error) {
            console.error(`Error fetching warehouses for location ${whOptn.value}:`, error);
            return [];
          }
        });
        const warehouseResults = await Promise.all(warehousePromises);
        warehouseOptions = warehouseResults.flat();
      } catch (error) {
        console.error(`Error fetching warehouses for location:`, error);
      }

      setUpliftVarianceWarehouses(warehouseOptions);
    }
    else {
      setUpliftVarianceWarehouses([]);
    }

  }
  
  const onUpliftVarianceWarehouseChange = (data) => {
    setReportFilter(prev => ({
      ...prev,
      warehouseId: data?.value ?? '', 
      store: data?.store || null
    }));
  };

  return (
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
          <div className="flexRow width100 justifyContentFlexStart alignItemsCenter">

{optionsSectorFilter ? (<div className='orderBy-div m-2 margLeft' style={{paddingBottom:'0.2rem'}}>
                          <Select
                            options={optionsSectorFilter}
                            defaultValue={state.sectorSelect[0]?.label ? state.sectorSelect[0]?.label : ''}
                            value={optionsSectorFilter?.filter(function (option) {
                              return (
                                state.sectorSelect.length && state.sectorSelect[0]&&
                                state.sectorSelect.find((sc) => sc.label === option.label)
                              );
                            })}
                            onChange={onChangeSectors}
                            styles={customSelSearch(themedColor)}
                            placeholder="Search Sector"
                            isSearchable={true}
                            isClearable={true}
                            className="selectMenu-meals"
                          />
                        </div>):<></>}

            <button className="orderStatus-div m-2">
            <>
                    <NGODatePicker
                      style={{width: '10rem',border:'0.7px solid #fff'}}
                      value={state.flightDate}
                      dateFormat="dd/MM/yyy"
                      name='flightDate'
                      className="input-margin"
                      minDate={viewOnly?state.minDate:null}
                      maxDate={viewOnly?state.maxDate:null}
                      isClearable={false}
                      placeholder={"Flight date"}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChange} />
                  </>
            </button>

            {!viewOnly?<button className="orderBy-div m-2 margLeft">
              <CustomSelect
                options={optionsLocations}
                placeHolder="Search location"
                onChange={onChangeLocation}
              />
            </button>:null}
            <button className="orderBy-div m-2 margLeft">
              <CustomSelect
                options={optionsWarehouse}
                placeHolder="Search warehouse"
                disabled={!viewOnly?false:true}
                value={optionsWarehouse.filter(option=>option.value===state.warehouseSel)}
                onChange={onWarehouseChange}
              />
            </button>

          {!viewOnly? <button className='saleType-div m-2' style={{marginLeft:"1rem"}}>
                    <CustomSelect options={itemTypeList} placeHolder="Search Status" onChange={onItemTypeChange} />
                </button>:null}
         <div className='flexRow justifyContentFlexStart margLeft7'>
         {downloadUplift && !viewOnly ? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading || isLoadingCateringGroups ? (
                                <img
                                  src={LoadingGIF}
                                  className="icon-size"
                                  style={{ width: '25px', height: '24px'}}
                                  alt="Loading"
                                />
                              ) : (

                                  <button
                                    disabled={isDownloading || isLoadingCateringGroups}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={"Download Reports"}
                                    onClick={showDownloadHandler}
                                  >
                                    <img src={downloadMasterIcon} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}
          </div>
                    <div className='flexRow width100 justifyContentFlexStart'>
                   {pendingCount.total>0 ? <div className="width100 flexRow alignItemsCenter justifyContentCenter">
          
                <IoFlask color={'#e68a00'} size={20}/>&nbsp;<span title={`${pendingCount.pending} uplifts pending out of a total of ${pendingCount.total >= UPLIFT_MAX_LIMIT ? `${pendingCount.total}+` : pendingCount.total}`} className='pending-count-disp'>{pendingCount.pending} / {pendingCount.total >= UPLIFT_MAX_LIMIT ? `${pendingCount.total}+` : pendingCount.total}</span>
          
                    </div>:<></>}
                    </div>

  { createUplifts && !viewOnly ?<div className='flexRow width100 justifyContentFlexEnd'>
            <div className='flexRow alignItemsCenter'>
                <button className="add-item-button" onClick={ onAddItemHandler }>
                  {t('pages.inventoryContent.uplifts.createUplift')}
                </button>

              </div>

          </div>:<></>}
          </div>



          <DataGrid
            ref={tableRef}
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            pageType="uplifts"   
            searchKey={searchKey}
            selItemType={itemType}
            onColumnResizedHandler={onColumnResizedHandler}
            resetDataSource={state.isReloadTableData}
            getRows={fetchUplifts}
            rowSelection="multiple"
            onAddItemHandler={() => onAddItemHandler()}
            noResultsMessage={message}
          />
        </>
      }
       {
        state && Boolean(state.selected) ?
         (state.selected.action === 'AddItem' || state.selected.action === 'ViewItem') && viewUplifts ? (
          <EditModal
           disabled={buttonStatus}
            key={state.selected.action}
            title={(state.selected.action === 'AddItem') ? 'Create Uplift' : (state.selected.action !== 'EditNewItem') ? 'Uplift -'+state.selected.storeName : 'View Items (Csv)'  }
            onClose={onClose}
            onSubmit={onEditSubmit}
            setIsDropdownOpen={setIsDropdownOpen}
            customContentHeight={ModalContHeight}
            modalFormStatusObj={modalFormStatusObj}
            showDone={true}
            buttonLabel={'Continue'}
            onChange = {onFieldChangeHandler}
            showFieldsInColumn={true}
            fields={
              state.selected.action === 'ViewItem' ?
                EditFormFields.map( (elt) => {
                  return {...elt, initialValue: state.selected[elt.attribute]}
                })
              :
              AddFormFields.map( (elt) => {
                return {...elt, initialValue:""}
              })
            }
          />
        ) : state.selected.action === 'EditItem' && editUplifts ? (
            toUpliftNavigate()
        ) : state.selected.action === 'CancelItem' ? (
          <CancelModal
          title={t('pages.inventoryContent.uplifts.cancelUplift')}
          onClose={onClose}
          error={promptError}
          onSubmit={onPromptSubmit}
          modalFormStatusObj={modalFormStatusObj}
          fields={
            EditFormFields.map( (elt) => {
              return {...elt, initialValue: state.selected}
            })
          }
          />
        ) : state.selected.action === 'CartItem' ?(
          <CartModal
          title={t('pages.inventoryContent.uplifts.addCarts')}
          onClose={onClose}
          />
        ) :  state.selected.action === 'ConfirmItem'?(
        <ConfirmModal
        title={t('pages.inventoryContent.uplifts.confirmUplift')}
        onClose={onClose}
        error={promptError}
        onSubmit={onPromptSubmit}
        modalFormStatusObj={modalFormStatusObj}
        fields={
          EditFormFields.map( (elt) => {
            return {...elt, initialValue: state.selected}
          })
        }
        />)
        :
        (state.selected.action === 'reviewRequested' || state.selected.action === 'awaitingItemScanAndLoad' || state.selected.action === 'requestCateringReview') ?(
          <div className='flexRow width100'>
          <EditModal
            key={state.selected.action}
            title={ modalTitle }
            onClose={onClose}
            mainContentCenter={true}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={onEnableDisableAction}
            showFieldsInColumn={true}
            customContentHeight={ModalContHeight}
            setIsDropdownOpen={setIsDropdownOpen}
            modalCustomButtons={modalCustomButtons}
            fields={EditFieldsCess.map( (elt) => {
              return { ...elt, initialValue: state.selected[elt.attribute] }
              })
            }
          />
          </div>)
        : state.selected.action === 'QRCode' && printUplifts ? (
          <QRCodeModal
        title="QR Code - Uplift"
        onClose={onClose}
        fields={state.selected}
        />
        ):null
        :null
      }
      {
        showUpliftSector.sector && viewUplifts &&
        <UpliftActionModal
        title={state.selected.action === 'sector' ? "Sectors Included" : "Uplift update status"}
        onClose={onClose}
        onSubmit={onPromptSubmit}
        fields={state.selected.action === 'sector' ? state.selected.sectors : ['No Updates Available']}
        />
      }
      {
        showUpliftSector.updateSector && viewUplifts &&
        <UpliftActionModal
        title={"Uplift update status"}
        onClose={onClose}
        onSubmit={onPromptSubmit}
         fields={state.selected.sectors}
        />
      }

      {
        showDownload && (
          <div className="overlay" role="dialog">
            <div className="dialog sm-scrollbar">
              <div className="dialog__content">
              <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
                  <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width50">Download Uplift Reports</h2>
              <button className='close-btn-ht' onClick={onUploadClose}>
                <img src={closeIcon} alt="close" data-icon='close'/>
              </button>
             </div>
                <hr />

                <div className="dialog__body_container flexRow mt-4 justifyContentCenter flexWrap">
                  <div className={`dialog__container_item input-container`}>
                    <div className='flexCol'>
                      <label htmlFor="reportType" className="req">Report type</label>
                      <select onChange={(e)=>setReportFilter(prev=>({...prev,reportType:e.target.value}))} name="" id="" className='select-input-galley1'  style={{minWidth:cateringGroupWidth}}>
                        <option value="">Select Report type</option>
                        <option value="upliftReport">Uplift Report</option>
                        <option value="upliftVarianceReport">Uplift Variance Report</option>
                      </select>
                    </div>

                    {reportFilter.reportType === "upliftReport" && (
                      <>
                        <div style={{marginBottom:"0.9rem"}} className='flexCol'>
                          <label style={{marginBottom:"0.9rem"}} htmlFor="reportType">Select Route</label>
                          <Select
                          isClearable
                          isSearchable
                          options={optionsSectorFilter}
                          placeholder="Select Route"
                          styles={{
                            placeholder:(styles,state) => ({ ...styles, textAlign: "left",color:  state.isFocused ? themedColor.background : '#fff' }),
                            indicatorSeparator: (provided) => ({ ...provided,display: 'none'}),
                            singleValue: (styles) => ({ ...styles,textAlign:"left",color:"#fff" }),
                            input: (styles) => ({ ...styles,textAlign:"left",color:"#fff" }),
                          }}
                          onChange={data=>setReportFilter(prev=>({...prev,storeId:`${data?.value}`}))}
                          />
                        </div>
                        <div className='flexCol'>
                          <label htmlFor="startDate" className="req">Start Date</label>
                          <NGODatePicker
                            style={{width:cateringGroupWidth}}
                            value={reportFilter.startDate}
                            name="startDate"
                            isclearable={true}
                            placeholder={t('Start Date')}
                            placeholdertext={t('datePickerPlaceholder')}
                            onChange={onDateChangeRep}
                            maxDate={new Date()}
                          />
                        </div>
                        <div className='flexCol'>
                          <label htmlFor="startDate" className="req">End Date</label>
                          <NGODatePicker
                            style={{width:cateringGroupWidth}}
                            value={reportFilter.endDate}
                            name="endDate"
                            isclearable={true}
                            placeholder={t('End Date')}
                            placeholdertext={t('datePickerPlaceholder')}
                            onChange={onDateChangeRep}
                            maxDate={reportFilter.startDate ? (() => {
                            const maxFromStart = getEndDateMaxLimit(reportFilter.startDate);
                            const today = new Date();
                            return maxFromStart > today ? today : maxFromStart;
                            })() : new Date()}
                          />
                        </div>
                      </>
                    )}
                    
                    {reportFilter.reportType === 'upliftVarianceReport' && (
                      <>
                        <div className='flexCol'>
                          <label htmlFor="date" className="req">Date</label>
                          <NGODatePicker
                            style={{minWidth:cateringGroupWidth}}
                            value={reportFilter.date}
                            name="date"
                            isclearable={true}
                            placeholder={t('Date')}
                            placeholdertext={t('datePickerPlaceholder')}
                            onChange={onDateChangeRep}
                            maxDate={new Date()}
                          />
                        </div>

                        <div style={{marginBottom:"0.9rem"}} className='flexCol'>
<div className='flexRow justifyContentFlexStart'>
                          <label style={{marginBottom:"0.9rem"}} htmlFor="cateringGroup" className='req'>Catering Group</label>
                           {isLoadingCateringGroupsSelect ?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px'}} alt="Loading" />:<></>}
</div>
                          <Select
                          inputId='cateringGroup'
                          isClearable
                          isDisabled={isLoadingCateringGroupsSelect}
                          isSearchable
                          options={cateringGroupOptions}
                          placeholder="Select Catering Group"
                          styles={dialogSelectStyles}
                          value={cateringGroupOptions.filter(cg=>cg.value === reportFilter?.cateringGroup?.id)}
                          onChange={onCateringGroupChange}
                          />
                        </div>
                        <div style={{marginBottom:"0.9rem"}} className='flexCol'>
                          <label style={{marginBottom:"0.9rem"}} htmlFor="warehouseId" className='req'>Select Warehouse</label>
                          <Select
                          inputId='warehouseId'
                          isClearable
                          isSearchable
                          options={upliftVarianceWarehouses}
                          placeholder="Select Warehouse"
                          styles={dialogSelectStyles}
                          value={
                            (() => {
                              return upliftVarianceWarehouses.find(
                                lk => lk.value === reportFilter?.warehouseId
                              ) || null;
                            })()
                          }
                          onChange={ onUpliftVarianceWarehouseChange }
                          />
                        </div>
                      </>
                    )}

                    <div>
                    <button
                      type="button"
                      onClick={onDownloadReport}
                      className="btn btn-info mt-2"
                      style={{ color: "white", width: "100%" }}
                    >
                      <span>
                        <img
                          className="icon-size mt-1"
                          alt="downloadMaster"
                          src={downloadMasterIcon}
                        />
                      </span>
                      {isDownloading || (isLoadingCateringGroups && !isLoadingCateringGroupsSelect )? "Downloading...":"Download"}
                    </button>

                    </div>
                    {reportDownloadErr && (
                      <div className='mt-4'>
                        <p className='listErrorMessagesCls'>
                          {reportDownloadErr}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

        )
      }
      {!ready &&<div className='overlay_hide sub'></div>}
    </div>
  )
}